(() => {
  const GALLERY_SELECTOR = 'media-gallery[data-panthera-variant-sync="true"]';

  function getProductRoot(gallery) {
    return gallery?.closest('.product-information') || gallery?.closest('.shopify-section') || document;
  }

  function cleanVariantTitle(title) {
    if (!title || title === 'Default Title') return '';
    return String(title).trim();
  }

  function updateDisplayedTitle(gallery, variantTitle) {
    if (!gallery) return;

    const root = getProductRoot(gallery);
    const heading = root.querySelector('.product-details h1') || root.querySelector('h1');
    if (!heading) return;

    const baseTitle =
      gallery.dataset.pantheraProductTitle ||
      heading.dataset.pantheraBaseTitle ||
      heading.textContent.trim();

    if (!heading.dataset.pantheraBaseTitle) {
      heading.dataset.pantheraBaseTitle = baseTitle;
    }

    const cleanTitle = cleanVariantTitle(variantTitle);
    heading.textContent = cleanTitle ? `${baseTitle} — ${cleanTitle}` : baseTitle;
  }

  document.addEventListener('variant:update', (event) => {
    const productId = event.detail?.data?.productId;
    const resource = event.detail?.resource;
    if (!resource) return;

    requestAnimationFrame(() => {
      const galleries = Array.from(document.querySelectorAll(GALLERY_SELECTOR));
      const gallery =
        galleries.find((item) => {
          const root = getProductRoot(item);
          const picker = root.querySelector('variant-picker');
          return !productId || picker?.dataset?.productId === String(productId);
        }) || galleries[0];

      updateDisplayedTitle(gallery, resource.title || '');
    });
  });

  function initializeTitles() {
    document.querySelectorAll(GALLERY_SELECTOR).forEach((gallery) => {
      updateDisplayedTitle(gallery, gallery.dataset.pantheraCurrentVariantTitle || '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeTitles, { once: true });
  } else {
    initializeTitles();
  }
})();